import { Box, Typography } from '@mui/material';

import { Avatar } from '@/components';
import type { EventResponse } from '@/types';

interface MobileMarketInfoProps {
  event?: EventResponse;
  title?: string;
}

export function MobileMarketInfo({ event, title }: MobileMarketInfoProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
      <Avatar
        src={event?.icon || event?.image}
        alt={title || event?.title || 'Market'}
        size={32}
        sx={{ borderRadius: '6px' }}
      />
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{
          fontSize: '1rem',
          wordBreak: 'break-word',
          flex: 1,
          lineHeight: 1.3,
        }}
      >
        {title || event?.title || '-'}
      </Typography>
    </Box>
  );
}
